module.exports = __webpack_public_path__ + "static/media/arrow_yellow.ccd6ecec.svg";